import { NgModule } from '@angular/core';
import { DialogsStoreModule } from './store/module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [MatDialogModule, DialogsStoreModule],
})
export class DialogsModule {}
